import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Calendar, Shield, Clock, Award } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/images/assets/team-5.jpg" 
          alt="Happy family in comfortable home" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          {/* Left Content */}
          <div className="lg:col-span-2">
            {/* Trust Badge */}
            <div className="flex items-center gap-2 text-emerald-400 mb-3 md:mb-6">
              <Award size={20} className="flex-shrink-0" />
              <span className="text-lg md:text-2xl lg:text-3xl font-semibold whitespace-nowrap">25+ Years of Trusted Service</span>
            </div>

            <h1 className="font-heading font-extrabold text-[28px] sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-3 md:mb-4">
              Fast Service.<br />
              <span className="text-emerald-400">Expert Advice.</span><br />
              Honest Pricing.
            </h1>

            <p className="text-sm md:text-lg text-stone-300 mb-4 md:mb-6 leading-relaxed max-w-lg">
              While other HVAC companies focus on plumbing, electrical, even roofing - we pride ourselves on being experts at two things: <strong className="text-white">Heating & Cooling</strong> your home.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mb-4 md:mb-6">
              <Link to="/contact" className="btn-primary inline-flex items-center justify-center gap-2 py-3 px-5" data-testid="hero-estimate-btn">
                <Calendar size={18} />
                Get Free Estimate
              </Link>
              <a href="tel:8593576803" className="btn-secondary inline-flex items-center justify-center gap-2 bg-white/10 border-white/20 text-white hover:bg-white hover:text-slate-900 py-3 px-5" data-testid="hero-call-btn">
                <Phone size={18} />
                (859) 357-6803
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap gap-3 md:gap-4">
              <div className="flex items-center gap-1.5 text-stone-300 text-xs md:text-sm">
                <Shield className="text-emerald-400" size={14} />
                <span>Licensed & Insured</span>
              </div>
              <div className="flex items-center gap-1.5 text-stone-300 text-xs md:text-sm">
                <Clock className="text-emerald-400" size={14} />
                <span>Same-Day Service</span>
              </div>
              <div className="flex items-center gap-1.5 text-stone-300 text-xs md:text-sm">
                <Award className="text-emerald-400" size={14} />
                <span>Free 2nd Opinions</span>
              </div>
            </div>
          </div>

          {/* Right Card */}
          <div className="hidden lg:block">
            <div className="glass rounded-2xl p-6 shadow-2xl">
              <h3 className="font-heading font-bold text-xl text-slate-900 mb-3">Request A Service</h3>
              <p className="text-slate-600 text-sm mb-5">Get fast, reliable HVAC service from certified technicians.</p>
              <Link to="/contact" className="btn-primary w-full text-center block py-3" data-testid="hero-schedule-btn">
                Contact Us Now
              </Link>
              <p className="text-center text-xs text-slate-500 mt-3">Includes Complimentary Second Opinions!</p>
            </div>
            {/* Best of Lexington Badge */}
            <div className="mt-4 flex justify-center gap-3">
              <img 
                src="/images/assets/best-of-lexington-2026.webp" 
                alt="Best of Lexington 2026 Gold Winner" 
                className="w-32 h-auto drop-shadow-lg"
              />
              <img 
                src="/images/assets/nate-certified.png" 
                alt="NATE Certified Technicians" 
                className="w-32 h-auto drop-shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
